import { useCallback, useRef, useState } from "react";

export type UseControlledOptions<Value> = {
  defaultValue: Value;
  onChange?: (value: Value, ...args: any[]) => void;
};

export function useControlled<Value>(
  value: Value | undefined,
  { defaultValue, onChange }: UseControlledOptions<Value>
): [Value, (value: Value) => void] {
  const [stateValue, setStateValue] = useState(
    value !== undefined ? value : defaultValue
  );
  const isControlled = value !== undefined;
  const onChangeRef = useRef(onChange);

  const setValue = useCallback(
    (newValue: Value) => {
      if (!isControlled) {
        setStateValue(newValue);
      }
      onChangeRef.current?.(newValue);
    },
    [isControlled, onChangeRef]
  );

  return [isControlled ? value : stateValue, setValue];
}
